import template from './holidaySummary.html';
import controller from './holidaySummary.controller';
import './holidaySummary.scss';

let holidaySummaryComponent = {
  restrict: 'E',
  bindings: {
    pendingDays: '<',
    ownDays: '<',
    christmasDays: '<',
    lastYear: '<',
    isInception: '<',
    isManager: '<',
    insertedIn: '@',
    isMobileApp: '<',
  },
  template,
  controller
};

export default holidaySummaryComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/holidaySummary/holidaySummary.component.js